/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portals_Filter_WaitingInputs */

const cs_portals_filter_waiting = /** @type {(inputs: Portals_Filter_WaitingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Čeká na údaje`)
};

const en_portals_filter_waiting = /** @type {(inputs: Portals_Filter_WaitingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waiting for details`)
};

/**
* | output |
* | --- |
* | "Waiting for details" |
*
* @param {Portals_Filter_WaitingInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const portals_filter_waiting = /** @type {((inputs?: Portals_Filter_WaitingInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portals_Filter_WaitingInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_portals_filter_waiting(inputs)
	return cs_portals_filter_waiting(inputs)
});